//Lib 
import { mapState } from "vuex";

// Event, Dialog
import EventBus from "@/event/EventBus";

// Api
import api from '@/api/baseApi';

// Extend
import baseFixedRentalService from '@/scripts/fixedRental/baseFixedRentalService';

// Constant
import { ROUTE_URL } from '@/constant/route';
import { SETTINGS_FIXED_RENTAL_API } from "@/constant/apiSettings";
import { API_CALL_STATUS, POPUP_ID } from "@/constant/baseConstant";
import { ELEMENT_LIST_PERIOD, FIXED_RENTAL_STATUS } from "@/constant/fixedRental";

// Component 

export default {

    extends: baseFixedRentalService,

    computed: {
        ...mapState({
            user: state => state.auth.user,
        }),
    },

    data() {
        return {
            routeUrl: ROUTE_URL,
            listPeriod: ELEMENT_LIST_PERIOD,
            fixedRentalStatus: FIXED_RENTAL_STATUS,

            listMachineRequest: null,

            request: {
                campaignName: null,
                continueRunning: true,
                automaticallyRenewal: true,
            }
        };
    },

    props: {
        targetImage: {
            type: Object,
            default: null
        },
    },

    mounted() {
        if (this.targetImage) {
            this.request.campaignName = this.targetImage.campaignName;
            this.request.continueRunning = this.targetImage.continueRunning;
            this.request.automaticallyRenewal = true;
        }
    },

    methods: {

        //#region Processing event
        processingEvent(param) {
            this[param.event](param.data);
        },
        //#endregion 

        //#region Close this pop-up
        closeThisPopup() {
            this.closePopup(POPUP_ID.FIXED_RENTAL_SETTINGS);
        },
        //#endregion

        //#region Create object request
        createObjectRequest(object, request) {
            return {
                machineId: object.id,
                campaignName: request.campaignName,
                continueRunning: request.continueRunning,
                // automaticallyRenewal: request.automaticallyRenewal,
            }
        },
        //#endregion

        //#region Renewal fixed rental
        save() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            setTimeout(() => {
                let data = {
                    campaignName: this.request.campaignName,
                    listMachineSettings: [this.createObjectRequest(this.targetImage, this.request)],
                    deviceInformation: JSON.stringify(this.getInformationClient())
                }
                api.baseRequest(SETTINGS_FIXED_RENTAL_API.FIXED_RENTAL_SETTINGS, data)
                    .then(() => {
                        EventBus.$emit("processingEventRental", { event: "isLoadingElement", data: [this.targetImage.id] });
                        EventBus.$emit("processingEventRental", { event: "autoRefresh" });
                        this.closeThisPopup();
                        this.notificationSuccess(this.$t('bootMachine.renewalSuccessTitle'), this.$t('fixedRentalSettings.saveSuccessMessage'));
                        this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                    })
                    .catch(error => {
                        this.processCatchApiRequest(error, this.$t('bootMachine.bootFailed'))
                    });
            }, this.smoothTimeOut);
        }
        //#endregion
    },
}